import { SearchFilterInputSkeleton } from 'components/domain/filters/search-filter-input/SearchFilterInput.skeleton';

const FiltersSkeleton = SearchFilterInputSkeleton;

export default FiltersSkeleton;
